module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I hung up. But my hand rested on the telephone for several seconds as I considered how clumsy I had been talking to Father Tim. But there it was; at last I had made the call, and tomorrow I would see him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took my hand away from the phone and touched Aidan Hockaday’s picture again, the photo lying frameless and flat in the suitcase. I turned it over and read the poem once more, then felt someone watching me. But not a ghost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ruby stood in the bedroom doorway, wearing an old chambray shirt of mine with one button fastened at her waist and the shirt-tails dipping down around her knees. “How long have you been up?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not long.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She eyed my half-empty coffee cup and asked, “Is that fresh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Reheated from yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She made a face and walked through the clutter toward the kitchen alcove, where she started heating water in a teakettle and grinding coffee beans and otherwise making a lot of noise. “I’ll say it again,” she said. “Bachelors live like bears with furniture.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ruby turned and faced me, probably expecting me to crack wise. "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v(" But what could I say? I do live like a bear. Besides which, I was preoccupied with dialing the phone number of another long-neglected friend. As I heard ringing on the line, I asked Ruby, “What are your plans today?”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Meaning what, I’m on my own?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to see somebody. It’s important.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The line continued ringing. It was early yet. I had to give him time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ruby walked back to me. She saw the empty picture frame on the couch. And the handwritten poem on the back of the photograph.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She picked up the photo, read the poem, and no doubt reached the same conclusion I had: one and one might eventually add up to two, somewhere down some twisting line. She said, “Go take care of business, Hock.” And I felt a scribble of guilt that here was poor Ruby also starting to think like a cop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what could I say? Besides which, there was finally an answer on the line. A voice birthed in Ireland, full of annoyance for being roused from a fine Saturday morning lie-in: “Hello—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Do you really want to know?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The place was dark as ever at midday, full of gray smoke and the sounds of clicking billiard balls and mugs of Guinness and Harp’s being poured and drunk. The old mahogany-encased juke still resonated with “Ireland United.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was the usual hearty band of red-faced boyos debating political topics unexhausted since the days of Cromwell. And the barkeeper was still named Terry Nugent; although Terry Two, as he was now called, but the image of his father before him: round of belly and with a nose full of burst capillaries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here to Nugent’s bar we had come on this Saturday afternoon. Davy Mogaill and I, for auld lang syne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And here it was where we had first met, when it happened that the two of us were posted to the Morningside Heights station house. Nugent’s was essentially a snug for the tidy Irish enclave of Inwood back then, but it also attracted a large contingent of us Irish cops who worked the precincts of upper Manhattan and the nearby South Bronx. Now the place was a step back in time.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("In our younger days, Mogaill and I became a classic pair of cop ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v(" drinking buddies. I was a rookie in blue, my poor mother had just died from being used up by work, my marriage was in the early and obvious stages of meltdown, and I had a face full of innocent questions. There was Davy, bless him, to oblige my great need of a rabbi. He was ten years my senior and a widower, he had just earned his gold shield, and he was then the wisest cynic I knew.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When I first laid eyes on him, I naturally took Davy Mogaill to be the local barroom poet. His speech had enough of the old country in it to qualify him as an Ancient Order of Hibernia type, and there he was in his cups and quoting Brendan Behan, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was a broad-backed man of average height, with great stout arms that in the days of the gods might have held up the sky. He had many ambitions and few friends. I was unsurprised that he was a widower. In spite of his being a great talker and drinker, there was that private sadness to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the help of Davy’s generous advice, I got through most of the departmental ropes without hanging myself. I also survived the divorce agonies thanks to Davy and his useful wisdom. Later, thanks in part to Davy’s connections, I successfully put in for elite duty with the SCUM patrol. And then, in thanks for all he had done for me, I gradually lost touch with Davy, just as I had lost touch with Father Tim. Until now, of course, when I needed them both.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Davy I had actually needed a week ago. I was then closing down my last case, a matter of serial murder involving a poor sod of a carnival artist known by the street name Picasso. And Captain Mogaill was, after all, head of central homicide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He provided me with important support and assistance, which made this our usual one-sided relationship: Davy helped me, and I let him. But this time I at least had the decency to notice that my rabbi from the past was in great crisis with the present. He was drinking a lot, but not like in the old days, and not in the proper places. He kept a bottle in his desk, like some old newspaperman dead-ended on the police beat. And of the captaincy he had worked so many ambitious years to achieve, he told me, with sour resignation, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Here I am, the head of homicide in a homicidal town. Which makes me a fool, or maybe some kind of a pimp.”")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("I thought maybe a few jars and some fond remembrance of the ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v(" way it was might buck him up. So we made a vague date for a reunion at Nugent’s. Which was conveniently now, on this Saturday when I discovered the curious poetry.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A few hours ago, I had telephoned Davy Mogaill, and he was obliging, as usual. I told him I was traveling to Ireland, and why; I told him about the photograph, and the poem; I told him about Ruby; I told him I had to see him, right that very day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Had I heard the catch in Mogaill’s voice, the same as I heard in Father Tim’s? And, did I really want to know?")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Terry Two set down jiggers of Black Bush on the bar. He poured one for himself as well, in honor of our return. “A regular pair of prodigal sons,” he said we were. Davy took up his jar for a sniff before downing it, the way he always did, the tiny shot glass incongruous in his peasant’s paw.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To Nugent’s,” I said, raising my glass. Terry Two cheerfully lifted his own, and I added, “To the comfort in seeing how some things never change.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mogaill quickly set down his drink, making the moment awkward. He looked around the barroom for several seconds, finally fixing his sights on a dour, slight man who had taken a table near the door. He sat alone. His ruddy face was obscured by a tweed cap, a black-and-white beard and smoke curling up from a cigarette. His hands were folded around a mug of Coca-Cola.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Davy turned back to us. He smiled at Nugent, not pleasantly, and asked, “How much are the drinks today, Terry?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Three seventy-five,” Terry said. “A great bargain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much for the same during the week?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Three-fifty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mogaill pointed over a shoulder with his thumb, in the direction of the man with the Coca-Cola. “So that’s it, and even a better bargain when the little fellow isn’t around?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s Finn is all, and he’s only collecting the surcharge. It’s customary, for the Noraid, you know.” Nugent spoke a little faster than usual, and his wide pink face took on a reddish tone. “For the orphans and the widows, you see.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Mogaill turned to me. “Might we drink to truer comfort than unchanging things that result in widows and orphans?” He picked up his glass. ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I suggested, “Yesterday was my birthday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sláinte")]), _vm._v(" Mogaill put back his whiskey in agreement, Nugent and I did the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I then followed Mogaill’s baleful gaze over toward Finn again. The little man now stared back at us through his cigarette haze. Terry Two set us up with refreshers on the house, in honor of my birthday. But clearly, he had had his fill of us prodigals. He said to Mogaill, “What am I going to do about Finn and his friends? Call the cops?” He did not wait for an answer. He moved off to attend to his other customers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mogaill asked me, “Remember Finn and his gang?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I remember the surcharge on weekend drinks, and I remember it was the teetotalers always collecting the proceeds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aye, and where they sent those funds?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose the money never reached innocent hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, it was always for marching feet. Bloody IRA feet.” Mogaill picked up the gift drink, sniffed at it, drank it down. “Marching feet never changed a bloody thing, my friend. They only produced more marching feet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought, Speaking of marching feet … ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had wrapped my father’s soldier picture in plastic and slipped it between pages of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily News,")]), _vm._v(" which I had taken along to read on the subway. I now spread the paper open on the bar, to where the photograph was, faceup. I flipped it over to the poetry side and said, “Here’s what I want you to see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mogaill turned the photograph back over. “This would be your father?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Aidan Hockaday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s a good-looking man, Neil.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks, but it’s the poem I brought for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I flipped the photograph. Mogaill looked at the blue inked words. He said, “Sorry, but I haven’t got my specs.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I reached into my jacket and gave him mine, bifocals that Ruby had talked me into buying as an early birthday present to myself. Some birthday. Mogaill reluctantly put them on, and read aloud, “‘Drown all the dogs, said the fierce young woman. ‘They killed my goose and a cat. Drown, drown in the water butt … Drown all the dogs,’ said the fierce young woman.” He took off the glasses, handed them back, and said nothing. ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, what is it?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mystic doggerel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but do you recognize it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seldom have I known Davy Mogaill to be stingy with words, especially not with a few drinks inside him. But now here he was, in Nugent’s bar, of all places, silent as a clam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Another jar?” I suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I caught Terry Two’s eye and motioned for another round. Mogaill closed the newspaper over the photograph, and said quietly, “Put it away now, you’ll not want to be splashing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then again, an awkward moment as Mogaill slipped into private sadness. He looked away from me, straight ahead at the long mirror up behind the liquor bottles on the business side of the bar. I looked at the mirror, too, and saw in it the distant reflection of Finn. He had left the table by the door, and now stood off behind us, with his flinty gray eyes on our backs, and close enough to hear us when we spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you suppose he wants?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s have us an answer,” Mogaill said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Davy got down off his barstool and stepped over to Finn. The two men talked, but I heard nothing of their conversation; nor did I see anything besides Davy’s wide back. After a minute or so, Finn was apparently persuaded to leave the premises. All eyes trailed after Finn, with nobody the sorrier to watch him go, not the least of whom was Terry Two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Davy returned to his barstool, seeming his old expansive self; but all the same, holding something back. He called over Nugent and negotiated yet two more drinks, at the rate of three-fifty each. When the whiskey came, Davy sipped at his, pensively. Then, with a quick nod toward the door, he said, “Out with the bad, in with the good, eh?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Presuming it useless to ask straight-out what, exactly, had just happened to improve the atmosphere, I tried the oblique approach. “It’s been a long time away from here, and from so many old micks all in the same place at one time,” I said. “I don’t know that I follow the politics anymore.” ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What makes you think you ever did? What does a right-born American know about politics?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That he can be educated on the subject by any right-born Irishman such as yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mogaill laughed, but not happily. He said, “There are no politics in America, only elections.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought a moment, then said, “But there are so many politicians. The newspapers are quoting them every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aye, because politicians are full of certainties. And haven’t you noticed by now that newspapers are more interested in certainties than in the truth? And how they’re certainly not interested in the truth about politicians themselves?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which is?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s polite politicians, then there’s Finn and his gang, but they’re all the same: great snorting hogs forever in pursuit of power, which makes them violent fools. Of course, this is doubly so of Irish politicians, since Ireland has never held any power in the world. Hell, my American friend, Ireland hasn’t once produced a battleship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only battlers, and an army of poets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Poetry now. There’s the real hope of the Irish race, since everybody knows the gag about our luck, hey? The trouble with hope is that it only pays off when there’s some sense in back of it. And you know what brother Behan has said about sense and us folks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If it rained soup from heaven, the Irish would all be rushing out from their houses with forks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mogaill laughed again, no more happily. I ordered us more drinks, and decided the time was right to shift our conversation into the direct mode.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What sense do you make of poetry hidden behind the picture of an Irish soldier?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not my place to be making sense of this, Detective Hockaday.” Mogaill’s words were slurry, but carefully chosen. “The case is yours, I fear. And what grander case may a detective crack than the mystery of his own makings?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("We said nothing for a while. I, for one, considered all the brooding ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v(" I had to do during the long dark hours of flight to Ireland, to the place where my Uncle Liam would die; where I might see the very last of my father’s flesh, besides my own. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Do you really want to know?")]), _vm._v(" So much to brood about: politics, secret poetry, a soldier lost in the mist, my rabbi and my priest and the mist of hesitancy in their voices. And Ruby.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I finally said, “Did you ever think of maybe finding another woman for your life, Davy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How you do prick the ears and thirst the tongue!” Mogaill said. Then he called for more drinks. My head was already swirling, but I did not decline; I could think no more, but this did little to slow my talk, nor that of the barroom poet. Mogaill said, “I’m as regular as the next man in my nightly dreams of women, and I’ve learned one powerfully important thing that most of us never learn of our opposite creature.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which would be what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The allurement women hold for us men, my friend, is the allurement that Cape Hatteras holds out to sailors. Women are enormously dangerous, thus they are enormously fascinating.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s a woman I’m seeing …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so I did. So much, and for so long that daylight left Nugent’s time-streaked windows, replaced by shadows and dusk, then the forgiveness of the night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Forgiveness.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Got to be going,” I finally said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So soon?” said Mogaill, his eyes hazed by alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tomorrow, there’s a priest I’m seeing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“God bless you, Neil. Who would be this priest?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Father Tim Kelly, from Holy Cross parish in Hell’s Kitchen. An old family friend. Maybe he’ll make something of my father’s picture, and the poem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I left, drunk, for the subway. And Davy was suddenly on his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I remember Davy at the bar, asking Terry Two for the change of a dollar, for the telephone. And him wishing me safe home that night, and bon voyage for tomorrow; warning, “Sorry to say, Hock, there’ll be no easy sleep under your Irish roof.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("And I remember stumbling home to Ruby’s sweet disapproval, ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v(" and telling her, as we lay in bed, she in my grateful arms, “Davy talks pretty like me; prettier, to tell the truth, and he turns his words into walls even higher than my own.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("I thought, as I shut my eyes to the swirling ceiling, Do I have the right to claim forgiveness for trespassing in the private sadnesses of my friends? ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f911b1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter05.vue
// module id = 93
// module chunks = 0